import { ResourcesCell } from '../../../../_components/cells/ResourcesCell';
import { PreparedWorkload } from 'features/workload-optimization';

import {
  getWorkloadCpuConstraints,
  getWorkloadMemoryConstraintsV2,
  minMaxFormatter,
} from '../../../../_utils';

type WorkloadConstraintsCellProps = {
  workload: PreparedWorkload;
};

export const WorkloadConstraintsCell = ({
  workload,
}: WorkloadConstraintsCellProps) => {
  const containerConstraints =
    workload.workloadConfigV2.vpaConfig.containerConstraints?.[0];

  const cpuConstraints = getWorkloadCpuConstraints(containerConstraints?.cpu);
  const memoryConstraints = getWorkloadMemoryConstraintsV2(
    containerConstraints?.memory
  );

  return (
    <ResourcesCell
      cpu={minMaxFormatter(cpuConstraints)}
      memory={minMaxFormatter(memoryConstraints)}
      cpuSuffix={cpuConstraints.mode === 'percentage' ? '%' : 'CPU'}
      memorySuffix={memoryConstraints.mode === 'percentage' ? '%' : 'GiB'}
    />
  );
};
